export const generateUUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const boldKeys = [
  'guarantee_headline',
  'faq_headline',
  'cart_headline',
  'thisisfor_headline',
  'aboutme_headline',
  'detailed_headline_bullet_1',
  'detailed_headline_bullet_2',
  'detailed_headline_bullet_3',
  'detailed_headline',
  'topbar_headline',
  'objcrush_shortblurp_1_headline',
  'objcrush_shortblurp_2_headline',
  'objcrush_shortblurp_3_headline',
  'cart_section_1_headline',
  'cart_section_2_headline',
  'cart_section_3_headline',
  'minihero_sidebar_headline',
  'headline_1',
  'headline_2',
  'headline_3',
  'headline_4',
  'headline_5',
  'headline_6',
  'tx_sidebar_headline',
  'bold_blurp_1',
  'bold_blurp_2',
  'video_heading_1',
  'video_heading_2',
  'video_heading_3'
];

export const PAGE_TYPES = {
  //   learning: 'Information & Learning Pages',
  list: 'Checklists and Trackers for Tasks and Lists',
  calendar: 'Calendar & Schedule Pages',
  //   recipe: 'Recipes or Steps in a Process',
  'about me': 'About Me Page',
  journal: 'Journal or Workbook Pages'
};

export const PAGE_TYPES_REVERSED = {
  //   'Information & Learning Pages': 'learning',
  'Checklists and Trackers for Tasks and Lists': 'list',
  'Calendar & Schedule Pages': 'calendar',
  //   'Recipes or Steps in a Process': 'recipe',
  'About Me Page': 'about me',
  'Journal or Workbook Pages': 'journal'
} as { [key: string]: string };

export const MAIN_COLOR_1 = '#11bad5';
export const MAIN_COLOR_2 = '#11bad5';
export const MAIN_COLOR_3 = '#11bad5';
export const MAIN_COLOR_4 = '#11bad5';
export const MAIN_COLOR_5 = '#11bad5';
export const BACKGROUND_COLOR_1 = '#f1fcfe';
export const BACKGROUND_COLOR_2 = '#f1fcfe';
export const BACKGROUND_COLOR_3 = '#f1fcfe';
export const BACKGROUND_COLOR_4 = '#FFFFFF';
export const BASE_COLOR_1 = '#000000';
export const BASE_COLOR_2 = '#002C5C';
export const BASE_COLOR_3 = '#606060';
export const BASE_COLOR_4 = '#9A9A9A';
export const BASE_COLOR_DARK = '#FFFFFF';

export const DEFAULT_PALETTE = {
  id: 0,
  background_color1: BACKGROUND_COLOR_1,
  background_color2: BACKGROUND_COLOR_2,
  background_color3: BACKGROUND_COLOR_3,
  background_color4: BACKGROUND_COLOR_4,
  base_color1: BASE_COLOR_1,
  base_color2: BASE_COLOR_2,
  base_color3: BASE_COLOR_3,
  base_color4: BASE_COLOR_4,
  base_color_dark: BASE_COLOR_DARK,
  color1: MAIN_COLOR_1,
  color2: MAIN_COLOR_2,
  color3: MAIN_COLOR_3,
  color4: MAIN_COLOR_4,
  color5: MAIN_COLOR_5,
  name: 'Untitled - 2163f-86b2-6fdf-bd2c-ba2303b335c4'
};

export const DEFAULT_CATEGORIZED_PALETTE = {
  id: 0,
  palette_id: 0,
  name: 'default',
  mainColors: [
    {
      id: 0,
      value: MAIN_COLOR_1,
      name: 'Color 1'
    },
    {
      id: 1,
      value: MAIN_COLOR_2,
      name: 'Color 2'
    },
    {
      id: 2,
      value: MAIN_COLOR_3,
      name: 'Color 3'
    },
    {
      id: 3,
      value: MAIN_COLOR_4,
      name: 'Color 4'
    },
    {
      id: 4,
      value: MAIN_COLOR_5,
      name: 'Color 5'
    }
  ],
  backgroundColors: [
    {
      id: 0,
      value: BACKGROUND_COLOR_1,
      name: 'Background Color 1'
    },
    {
      id: 1,
      value: BACKGROUND_COLOR_2,
      name: 'Background Color 2'
    },
    {
      id: 2,
      value: BACKGROUND_COLOR_3,
      name: 'Background Color 3'
    },
    {
      id: 3,
      value: BACKGROUND_COLOR_4,
      name: 'Background Color 4'
    }
  ],
  baseColors: [
    {
      id: 0,
      value: BASE_COLOR_1,
      name: 'Base Color 1'
    },
    {
      id: 1,
      value: BASE_COLOR_2,
      name: 'Base Color 2'
    },
    {
      id: 2,
      value: BASE_COLOR_3,
      name: 'Base Color 3'
    },
    {
      id: 3,
      value: BASE_COLOR_4,
      name: 'Base Color 4'
    }
  ]
};

interface DefaultcomponentAccesoryItem {
  id: boolean;
  title?: boolean;
  content?: boolean;
  button?: boolean;
  benefits?: { id: boolean; title?: boolean; content?: boolean; button?: boolean }[];
}

export const DefaultComponentAccesories = {
  topbar: {
    id: true,
    button: true,
    content: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true
      },
      {
        id: true,
        title: true
      }
    ]
  },
  hero: {
    id: true,
    button: true,
    content: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  hero_basic: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  hero_detailed: {
    id: true,
    button: true,
    content: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  hero_coach: {
    id: true,
    button: true,
    content: true,
    title: true
  },
  mini_hero: {
    id: true,
    title: true,
    content: true
  },
  heading: {
    id: true,
    content: true,
    title: true
  },
  check_section: {
    id: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  for_you: {
    id: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      }
    ]
  },
  about_me: {
    id: true,
    title: true,
    content: true
  },
  guarantee: {
    id: true,
    title: true,
    content: true
  },
  video: {
    id: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  photo: {
    id: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      }
    ]
  },
  faq: {
    id: true,
    title: true,
    content: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  call_to_action: {
    id: true,
    title: true,
    button: true,
    benefits: [
      {
        id: true,
        content: true
      },
      {
        id: true,
        content: true
      },
      {
        id: true,
        content: true
      }
    ]
  },
  how_to_start: {
    id: true,
    title: true,
    content: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  },
  headline_only: {
    id: true,
    title: true
  },
  paragraph: {
    id: true,
    content: true
  },
  heading_with_button: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  heading_with_button_calendar: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  heading_with_button_event: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  heading_with_button_community: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  form: {
    id: true,
    title: true,
    content: true,
    button: true
  },
  recurring_form: {
    id: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      }
    ]
  },
  upsell_vip_form: {
    id: true,
    title: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true,
        button: true
      },
      {
        id: true,
        title: true,
        content: true,
        button: true
      }
    ]
  },
  receipt: {
    id: true
  },
  event: {
    id: true,
    title: true,
    content: true,
    benefits: [
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      },
      {
        id: true,
        title: true,
        content: true
      }
    ]
  }
} as Record<string, DefaultcomponentAccesoryItem>;

export const ERROR_MESSAGES_MAPPER = {
  sub_domain: {
    unique: 'Subdomain Already Exists'
  }
};

export const componentsData = [
  {
    name: 'Topbar',
    selector: 'topbar',
    items: [
      {
        id: 1,
        name: 'Two colors with button 1',
        img: '/img/components/topbar/topbar_illustr_1.jpg',
        version: 'V1',
        selector: 'topbar',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Two colors with button 1',
        img: '/img/components/topbar/topbar_illustr_2.jpg',
        version: 'V2',
        selector: 'topbar',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Top bar with Logo',
        img: '/img/components/topbar/topbar_illustr_3.jpg',
        version: 'V3',
        selector: 'topbar',
        benefitsCount: 2
      }
    ]
  },
  {
    name: 'Heroes',
    selector: 'hero',
    items: [
      {
        id: 1,
        name: 'Hero Basic V1',
        img: '/img/components/hero/hero_basic_V1.jpg',
        version: 'V1',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 2,
        name: 'Hero Basic V2',
        img: '/img/components/hero/hero_basic_V2.jpg',
        version: 'V2',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 3,
        name: 'Hero Basic V3',
        img: '/img/components/hero/hero_basic_V3.jpg',
        version: 'V3',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 4,
        name: 'Hero Basic V4',
        img: '/img/components/hero/hero_basic_V4.jpg',
        version: 'V4',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 5,
        name: 'Hero Coaching V1',
        img: '/img/components/hero/hero_coach_V1.jpg',
        version: 'V5',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 6,
        name: 'Hero Coaching V2',
        img: '/img/components/hero/hero_coach_V2.jpg',
        version: 'V6',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 7,
        name: 'Hero Basic V7',
        img: '/img/components/hero/hero_basic_V7.jpg',
        version: 'V7',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 8,
        name: 'Hero Basic V8',
        img: '/img/components/hero/hero_basic_V8.jpg',
        version: 'V8',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 9,
        name: 'Hero Basic V5',
        img: '/img/components/hero/hero_basic_V5.png',
        version: 'V9',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 10,
        name: 'Hero Basic V6',
        img: '/img/components/hero/hero_basic_V6.jpg',
        version: 'V10',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 11,
        name: 'Hero Detailed V1',
        img: '/img/components/hero/hero_detailed_V1.jpg',
        version: 'V11',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 12,
        name: 'Hero Detailed V2',
        img: '/img/components/hero/hero_detailed_V2.jpg',
        version: 'V12',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 13,
        name: 'Hero Detailed V3',
        img: '/img/components/hero/hero_detailed_V3.jpg',
        version: 'V13',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 14,
        name: 'Hero Detailed V4',
        img: '/img/components/hero/hero_detailed_V4.jpg',
        version: 'V14',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 15,
        name: 'Hero Detailed V5',
        img: '/img/components/hero/hero_detailed_V5.jpg',
        version: 'V15',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 16,
        name: 'Hero Detailed V6',
        img: '/img/components/hero/hero_detailed_V6.jpg',
        version: 'V16',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 17,
        name: 'Hero Detailed V7',
        img: '/img/components/hero/hero_detailed_V7.jpg',
        version: 'V17',
        selector: 'hero',
        benefitsCount: 3
      },
      {
        id: 18,
        name: 'Hero Detailed V8',
        img: '/img/components/hero/hero_detailed_V8.jpg',
        version: 'V18',
        selector: 'hero',
        benefitsCount: 3
      }
    ]
  },
  {
    name: 'Minihero',
    selector: 'mini_hero',
    items: [
      {
        id: 1,
        name: 'Minihero Left Image V1',
        img: '/img/components/miniHero/minihero_illustr_1.jpg',
        version: 'V1',
        selector: 'mini_hero',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Minihero Right Image V2',
        img: '/img/components/miniHero/minihero_illustr_2.jpg',
        version: 'V2',
        selector: 'mini_hero',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Sidebar',
    selector: 'check_section',
    items: [
      {
        id: 1,
        name: 'Sidebar Right Image V1',
        img: '/img/components/sidebar/sidebar_illustr_1.jpg',
        version: 'V1',
        selector: 'check_section',
        benefitsCount: 3
      },
      {
        id: 2,
        name: 'Sidebar Left Image V2',
        img: '/img/components/sidebar/sidebar_illustr_2.jpg',
        version: 'V2',
        selector: 'check_section',
        benefitsCount: 3
      }
    ]
  },
  {
    name: 'This Is For',
    selector: 'for_you',
    items: [
      {
        id: 1,
        name: 'This Is for You V1',
        img: '/img/components/thisIsFor/thisisfor_illustr_1.jpg',
        version: 'V1',
        selector: 'for_you',
        benefitsCount: 3
      },
      {
        id: 2,
        name: 'This Is for You V2',
        img: '/img/components/thisIsFor/thisisfor_illustr_2.jpg',
        version: 'V2',
        selector: 'for_you',
        benefitsCount: 3
      },
      {
        id: 3,
        name: 'This Is for You V3',
        img: '/img/components/thisIsFor/thisisfor_illustr_3.jpg',
        version: 'V3',
        selector: 'for_you',
        benefitsCount: 3
      }
    ]
  },
  {
    name: 'About Me',
    selector: 'about_me',
    items: [
      {
        id: 1,
        name: 'About Me Portrait Image V1',
        img: '/img/components/aboutme/aboutme_1.jpg',
        version: 'V1',
        selector: 'about_me',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'About Me Portrait Image V2',
        img: '/img/components/aboutme/aboutme_3.jpg',
        version: 'V2',
        selector: 'about_me',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'About Me Portrait Image V3',
        img: '/img/components/aboutme/aboutme_2.jpg',
        version: 'V3',
        selector: 'about_me',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Guarantee',
    selector: 'guarantee',
    items: [
      {
        id: 1,
        name: 'Guarantee V1',
        img: '/img/components/guarantee/guarantee_illustr_1.jpg',
        version: 'V1',
        selector: 'guarantee',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Guarantee V2',
        img: '/img/components/guarantee/guarantee_illustr_2.jpg',
        version: 'V2',
        selector: 'guarantee',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Guarantee V3',
        img: '/img/components/guarantee/guarantee_illustr_3.jpg',
        version: 'V3',
        selector: 'guarantee',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'FAQ',
    selector: 'faq',
    items: [
      {
        id: 1,
        name: 'FAQ V1',
        img: '/img/components/faqs/faq_illustr_1.jpg',
        version: 'V1',
        selector: 'faq',
        benefitsCount: 5
      },
      {
        id: 2,
        name: 'FAQ V2',
        img: '/img/components/faqs/faq_illustr_2.jpg',
        version: 'V2',
        selector: 'faq',
        benefitsCount: 5
      },
      {
        id: 3,
        name: 'FAQ V3',
        img: '/img/components/faqs/faq_illustr_3.jpg',
        version: 'V3',
        selector: 'faq',
        benefitsCount: 5
      }
    ]
  },
  {
    name: 'Call To Action',
    selector: 'call_to_action',
    items: [
      {
        id: 1,
        name: 'Call To Action V1',
        img: '/img/components/calltoaction/calltoaction_illustr_1.jpg',
        version: 'V1',
        selector: 'call_to_action',
        benefitsCount: 3
      },
      {
        id: 2,
        name: 'Call To Action V2',
        img: '/img/components/calltoaction/calltoaction_illustr_2.jpg',
        version: 'V2',
        selector: 'call_to_action',
        benefitsCount: 3
      }
    ]
  },
  {
    name: 'Video',
    selector: 'video',
    items: [
      {
        id: 1,
        name: 'Video V1',
        img: '/img/components/video/video_illustr_1.jpg',
        version: 'V1',
        selector: 'video',
        benefitsCount: 1
      },
      {
        id: 2,
        name: 'Video V2',
        img: '/img/components/video/video_illustr_2.jpg',
        version: 'V2',
        selector: 'video',
        benefitsCount: 1
      },
      {
        id: 3,
        name: 'Video V3',
        img: '/img/components/video/video_illustr_3.jpg',
        version: 'V3',
        selector: 'video',
        benefitsCount: 2
      },
      {
        id: 4,
        name: 'Video V4',
        img: '/img/components/video/video_illustr_4.jpg',
        version: 'V4',
        selector: 'video',
        benefitsCount: 1
      },
      {
        id: 5,
        name: 'Video V5',
        img: '/img/components/video/video_illustr_5.jpg',
        version: 'V5',
        selector: 'video',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Photo',
    selector: 'photo',
    items: [
      {
        id: 1,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_1.jpg',
        version: 'V1',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 2,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_2.jpg',
        version: 'V2',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 3,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_3.jpg',
        version: 'V3',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 4,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_4.jpg',
        version: 'V4',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 5,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_5.jpg',
        version: 'V5',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 6,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_6.png',
        version: 'V6',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 7,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_7.jpg',
        version: 'V7',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 8,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_8.png',
        version: 'V8',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 9,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_9.jpg',
        version: 'V9',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 10,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_10.jpg',
        version: 'V10',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 11,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_11.png',
        version: 'V11',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 12,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_12.jpg',
        version: 'V12',
        selector: 'photo',
        benefitsCount: 2
      },
      {
        id: 13,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_13.jpg',
        version: 'V13',
        selector: 'photo',
        benefitsCount: 3
      },
      {
        id: 14,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_14.jpg',
        version: 'V14',
        selector: 'photo',
        benefitsCount: 3
      },
      {
        id: 15,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_15.jpg',
        version: 'V15',
        selector: 'photo',
        benefitsCount: 4
      }
    ]
  },
  {
    name: 'How To Get Started',
    selector: 'how_to_start',
    items: [
      {
        id: 1,
        name: 'How To Get Started V1',
        img: '/img/components/3parts/3parts_illustr_1.jpg',
        version: 'V1',
        selector: 'how_to_start',
        benefitsCount: 3
      },
      {
        id: 2,
        name: 'How To Get Started V2',
        img: '/img/components/3parts/3parts_illustr_2.jpg',
        version: 'V2',
        selector: 'how_to_start',
        benefitsCount: 3
      },
      {
        id: 3,
        name: 'How To Get Started V3',
        img: '/img/components/3parts/3parts_illustr_3.jpg',
        version: 'V3',
        selector: 'how_to_start',
        benefitsCount: 3
      }
    ]
  },
  {
    name: 'Headline Only',
    selector: 'headline_only',
    items: [
      {
        id: 1,
        name: 'Headline Only V1',
        img: '/img/components/headlineOnly/headline_only_illustr_1.jpg',
        version: 'V1',
        selector: 'headline_only',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Headline Only V2',
        img: '/img/components/headlineOnly/headline_only_illustr_2.jpg',
        version: 'V2',
        selector: 'headline_only',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Paragraph',
    selector: 'paragraph',
    items: [
      {
        id: 1,
        name: 'Paragraph V1',
        img: '/img/components/paragraph/paragraph_only_illustr_1.jpg',
        version: 'V1',
        selector: 'paragraph',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Paragraph V2',
        img: '/img/components/paragraph/paragraph_only_illustr_2.jpg',
        version: 'V2',
        selector: 'paragraph',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Headline and Subheadline',
    selector: 'heading',
    items: [
      {
        id: 1,
        name: 'Headline and Subheadline V1',
        img: '/img/components/headline_subheadline/head_sub_illustr_1.jpg',
        version: 'V1',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Headline and Subheadline V2',
        img: '/img/components/headline_subheadline/head_sub_illustr_2.jpg',
        version: 'V2',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Headline and Subheadline V3',
        img: '/img/components/headline_subheadline/head_sub_illustr_v3.jpg',
        version: 'V3',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 4,
        name: 'Headline and Subheadline V4',
        img: '/img/components/headline_subheadline/head_sub_illustr_v4.jpg',
        version: 'V4',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 5,
        name: 'Headline and Subheadline V5',
        img: '/img/components/headline_subheadline/head_sub_illustr_v5.jpg',
        version: 'V5',
        selector: 'heading',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Heading With Button',
    selector: 'heading_with_button',
    items: [
      {
        id: 1,
        name: 'Headline With Button V1',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_1.jpg',
        version: 'V1',
        selector: 'heading_with_button',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Headline With Button V2',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_2.jpg',
        version: 'V2',
        selector: 'heading_with_button',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Headline With Button V3',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_3.jpg',
        version: 'V3',
        selector: 'heading_with_button',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Heading With Button Event',
    selector: 'heading_with_button_event',
    items: [
      {
        id: 1,
        name: 'Headline With Button V1',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_1.jpg',
        version: 'V1',
        selector: 'heading_with_button_event',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Heading With Button Community',
    selector: 'heading_with_button_community',
    items: [
      {
        id: 1,
        name: 'Headline With Button V1',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_1.jpg',
        version: 'V1',
        selector: 'heading_with_button_community',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Heading With Button Calendar',
    selector: 'heading_with_button_calendar',
    items: [
      {
        id: 1,
        name: 'Headline With Button V1',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_1.jpg',
        version: 'V1',
        selector: 'heading_with_button_calendar',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Events',
    selector: 'event',
    items: [
      {
        id: 1,
        name: 'Event V1',
        img: '/img/components/events/event_illustr_1.jpg',
        version: 'V1',
        selector: 'event',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Event V2',
        img: '/img/components/events/event_illustr_2.jpg',
        version: 'V2',
        selector: 'event',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Event V3',
        img: '/img/components/events/event_illustr_3.jpg',
        version: 'V3',
        selector: 'event',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Forms',
    selector: 'form',
    items: [
      {
        id: 1,
        name: 'Form V1',
        img: '/img/components/form/order_withbar_illustr_6.jpg',
        version: 'V1',
        selector: 'form',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Form V2',
        img: '/img/components/form/order_withbar_illustr_7.jpg',
        version: 'V2',
        selector: 'form',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Recurring Forms',
    selector: 'recurring_form',
    items: [
      {
        id: 1,
        name: 'Recurring Form V1',
        img: '/img/components/form/order_withbar_illustr_8.jpg',
        version: 'V1',
        selector: 'recurring_form',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Recurring Form V2',
        img: '/img/components/form/order_withbar_illustr_9.jpg',
        version: 'V2',
        selector: 'recurring_form',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Recurring Form V3',
        img: '/img/components/form/order_withbar_illustr_10.jpg',
        version: 'V3',
        selector: 'recurring_form',
        benefitsCount: 0
      },
      {
        id: 4,
        name: 'Recurring Form V4',
        img: '/img/components/form/order_withbar_illustr_11.jpg',
        version: 'V4',
        selector: 'recurring_form',
        benefitsCount: 0
      },
      {
        id: 5,
        name: 'Recurring Form V5',
        img: '/img/components/form/order_withbar_illustr_12.jpg',
        version: 'V5',
        selector: 'recurring_form',
        benefitsCount: 0
      },
      {
        id: 6,
        name: 'Recurring Form V6',
        img: '/img/components/form/order_withbar_illustr_13.jpg',
        version: 'V6',
        selector: 'recurring_form',
        benefitsCount: 0
      }
    ]
  },
  {
    name: 'Upsell Forms',
    selector: 'upsell_vip_form',
    items: [
      {
        id: 1,
        name: 'Upsell Form V1',
        img: '/img/components/form/order_withbar_illustr_8.jpg',
        version: 'V1',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      },
      {
        id: 2,
        name: 'Upsell Form V2',
        img: '/img/components/form/order_withbar_illustr_9.jpg',
        version: 'V2',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      },
      {
        id: 3,
        name: 'Upsell Form V3',
        img: '/img/components/form/order_withbar_illustr_10.jpg',
        version: 'V3',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      },
      {
        id: 4,
        name: 'Upsell Form V4',
        img: '/img/components/form/order_withbar_illustr_11.jpg',
        version: 'V4',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      },
      {
        id: 5,
        name: 'Upsell Form V5',
        img: '/img/components/form/order_withbar_illustr_12.jpg',
        version: 'V5',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      },
      {
        id: 6,
        name: 'Upsell Form V6',
        img: '/img/components/form/order_withbar_illustr_13.jpg',
        version: 'V6',
        selector: 'upsell_vip_form',
        benefitsCount: 0
      }
    ]
  }
];

export const userSelectionMapper = {
  hero: ['hero', 'hero_detailed'],
  check_section: ['check_section', 'mini_hero'],
  headline_only: ['headline_only', 'heading', 'heading_with_button'],
  for_you: ['for_you', 'how_to_start']
};

export const userComponentSelection = [
  {
    name: 'Saved Components',
    selector: [],
    items: []
  },
  {
    name: 'components.topBar',
    selector: 'topbar',
    items: [
      {
        id: 1,
        name: 'components.topBarCTAWithButton',
        img: '/img/components/topbar/topbar_illustr_1.jpg',
        version: 'V1',
        selector: 'topbar',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.topBarLogoWithButton',
        img: '/img/components/topbar/topbar_illustr_2.jpg',
        version: 'V2',
        selector: 'topbar',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.topBarLogoAndLinksWithButton',
        img: '/img/components/topbar/topbar_illustr_3.jpg',
        version: 'V3',
        selector: 'topbar',
        benefitsCount: 2,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.hero',
    selector: 'hero',
    items: [
      {
        id: 1,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V1.jpg',
        version: 'V1',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 2
      },
      {
        id: 2,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V2.jpg',
        version: 'V2',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 4
      },
      {
        id: 3,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_basic_V3.jpg',
        version: 'V3',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 6
      },
      {
        id: 4,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V4.jpg',
        version: 'V4',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 8
      },
      {
        id: 5,
        name: 'components.heroCoaching',
        img: '/img/components/hero/hero_coach_V1.jpg',
        version: 'V5',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 10
      },
      {
        id: 6,
        name: 'components.heroCoaching',
        img: '/img/components/hero/hero_coach_V2.jpg',
        version: 'V6',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 12
      },
      {
        id: 7,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V7.jpg',
        version: 'V7',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 14
      },
      {
        id: 8,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V8.jpg',
        version: 'V8',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 16
      },
      {
        id: 9,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V5.png',
        version: 'V9',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 18
      },
      {
        id: 10,
        name: 'components.heroBasic',
        img: '/img/components/hero/hero_basic_V6.jpg',
        version: 'V10',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 20
      },
      {
        id: 11,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V1.jpg',
        version: 'V11',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 1
      },
      {
        id: 12,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V2.jpg',
        version: 'V12',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 3
      },
      {
        id: 13,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V3.jpg',
        version: 'V13',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 5
      },
      {
        id: 14,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V4.jpg',
        version: 'V14',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 7
      },
      {
        id: 15,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V5.jpg',
        version: 'V15',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 9
      },
      {
        id: 16,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V6.jpg',
        version: 'V16',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 11
      },
      {
        id: 17,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V7.jpg',
        version: 'V17',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 13
      },
      {
        id: 18,
        name: 'components.heroDetailed',
        img: '/img/components/hero/hero_detailed_V8.jpg',
        version: 'V18',
        selector: 'hero',
        benefitsCount: 3,
        translationForVersion: true,
        order: 15
      }
    ]
  },
  {
    name: 'components.sidebar',
    selector: 'mini_hero',
    items: [
      {
        id: 1,
        name: 'components.miniHeroLeftImage',
        img: '/img/components/miniHero/minihero_illustr_1.jpg',
        version: 'V1',
        selector: 'mini_hero',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.miniHeroRightImage',
        img: '/img/components/miniHero/minihero_illustr_2.jpg',
        version: 'V2',
        selector: 'mini_hero',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.sidebarRightImage',
        img: '/img/components/sidebar/sidebar_illustr_1.jpg',
        version: 'V1',
        selector: 'check_section',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 4,
        name: 'components.sidebarLeftImage',
        img: '/img/components/sidebar/sidebar_illustr_2.jpg',
        version: 'V2',
        selector: 'check_section',
        benefitsCount: 3,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.threePartSection',
    selector: 'for_you',
    items: [
      {
        id: 1,
        name: 'components.thisIsForYou',
        img: '/img/components/thisIsFor/thisisfor_illustr_1.jpg',
        version: 'V1',
        selector: 'for_you',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.thisIsForYou',
        img: '/img/components/thisIsFor/thisisfor_illustr_2.jpg',
        version: 'V2',
        selector: 'for_you',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.thisIsForYou',
        img: '/img/components/thisIsFor/thisisfor_illustr_3.jpg',
        version: 'V3',
        selector: 'for_you',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 4,
        name: 'components.howToGetStarted',
        img: '/img/components/3parts/3parts_illustr_1.jpg',
        version: 'V1',
        selector: 'how_to_start',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 5,
        name: 'components.howToGetStarted',
        img: '/img/components/3parts/3parts_illustr_2.jpg',
        version: 'V2',
        selector: 'how_to_start',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 6,
        name: 'components.howToGetStarted',
        img: '/img/components/3parts/3parts_illustr_3.jpg',
        version: 'V3',
        selector: 'how_to_start',
        benefitsCount: 3,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.aboutMe',
    selector: 'about_me',
    items: [
      {
        id: 1,
        name: 'components.aboutMePortraitImage',
        img: '/img/components/aboutme/aboutme_1.jpg',
        version: 'V1',
        selector: 'about_me',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.aboutMePortraitImage',
        img: '/img/components/aboutme/aboutme_3.jpg',
        version: 'V2',
        selector: 'about_me',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.aboutMeLandscapeImage',
        img: '/img/components/aboutme/aboutme_2.jpg',
        version: 'V3',
        selector: 'about_me',
        benefitsCount: 0,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.headlinesAndButtons',
    selector: ['headline_only', 'heading', 'heading_with_button'],
    items: [
      {
        id: 1,
        name: 'components.headlineOnly',
        img: '/img/components/headlineOnly/headline_only_illustr_1.jpg',
        version: 'V1',
        selector: 'headline_only',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.headlineOnly',
        img: '/img/components/headlineOnly/headline_only_illustr_2.jpg',
        version: 'V2',
        selector: 'headline_only',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.headlineAndSubheadline',
        img: '/img/components/headline_subheadline/head_sub_illustr_1.jpg',
        version: 'V1',
        selector: 'heading',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 4,
        name: 'components.headlineAndSubheadline',
        img: '/img/components/headline_subheadline/head_sub_illustr_2.jpg',
        version: 'V2',
        selector: 'heading',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 5,
        name: 'components.headlineAndSubheadline',
        img: '/img/components/headline_subheadline/head_sub_illustr_v3.jpg',
        version: 'V3',
        selector: 'heading',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 6,
        name: 'Headline and Subheadline V4',
        img: '/img/components/headline_subheadline/head_sub_illustr_v4.jpg',
        version: 'V4',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 7,
        name: 'Headline and Subheadline V5',
        img: '/img/components/headline_subheadline/head_sub_illustr_v5.jpg',
        version: 'V5',
        selector: 'heading',
        benefitsCount: 0
      },
      {
        id: 8,
        name: 'components.headlineWithButton',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_1.jpg',
        version: 'V1',
        selector: 'heading_with_button',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 9,
        name: 'components.headlineWithButton',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_2.jpg',
        version: 'V2',
        selector: 'heading_with_button',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 10,
        name: 'components.headlineWithButton',
        img: '/img/components/heading_withbutton/heading_withbutton_illustr_3.jpg',
        version: 'V3',
        selector: 'heading_with_button',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 11,
        name: 'components.callToAction',
        img: '/img/components/calltoaction/calltoaction_illustr_1.jpg',
        version: 'V1',
        selector: 'call_to_action',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 12,
        name: 'components.callToAction',
        img: '/img/components/calltoaction/calltoaction_illustr_2.jpg',
        version: 'V2',
        selector: 'call_to_action',
        benefitsCount: 3,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.videoOrImage',
    selector: ['photo', 'video'],
    items: [
      {
        id: 1,
        name: 'components.video',
        img: '/img/components/video/video_illustr_1.jpg',
        version: 'V1',
        selector: 'video',
        benefitsCount: 1,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.video',
        img: '/img/components/video/video_illustr_2.jpg',
        version: 'V2',
        selector: 'video',
        benefitsCount: 1,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.video',
        img: '/img/components/video/video_illustr_3.jpg',
        version: 'V3',
        selector: 'video',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 4,
        name: 'components.video',
        img: '/img/components/video/video_illustr_4.jpg',
        version: 'V4',
        selector: 'video',
        benefitsCount: 1,
        translationForVersion: true
      },
      {
        id: 5,
        name: 'components.video',
        img: '/img/components/video/video_illustr_5.jpg',
        version: 'V5',
        selector: 'video',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 6,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_1.jpg',
        version: 'V1',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 7,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_2.jpg',
        version: 'V2',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 8,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_3.jpg',
        version: 'V3',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 9,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_4.jpg',
        version: 'V4',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 10,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_5.jpg',
        version: 'V5',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 11,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_6.png',
        version: 'V6',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 12,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_7.jpg',
        version: 'V7',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 13,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_8.png',
        version: 'V8',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 14,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_9.jpg',
        version: 'V9',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 15,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_10.jpg',
        version: 'V10',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 16,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_11.png',
        version: 'V11',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 17,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_12.jpg',
        version: 'V12',
        selector: 'photo',
        benefitsCount: 2,
        translationForVersion: true
      },
      {
        id: 18,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_13.jpg',
        version: 'V13',
        selector: 'photo',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 19,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_14.jpg',
        version: 'V14',
        selector: 'photo',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 20,
        name: 'components.photo',
        img: '/img/components/image/image_illustr_15.jpg',
        version: 'V15',
        selector: 'photo',
        benefitsCount: 4,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.paragraphHeadline',
    selector: 'paragraph',
    items: [
      {
        id: 1,
        name: 'components.paragraph',
        img: '/img/components/paragraph/paragraph_only_illustr_1.jpg',
        version: 'V1',
        selector: 'paragraph',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.paragraph',
        img: '/img/components/paragraph/paragraph_only_illustr_2.jpg',
        version: 'V2',
        selector: 'paragraph',
        benefitsCount: 0,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.other',
    selector: ['faq', 'guarantee', 'form'],
    items: [
      {
        id: 1,
        name: 'components.faq',
        img: '/img/components/faqs/faq_illustr_1.jpg',
        version: 'V1',
        selector: 'faq',
        benefitsCount: 5,
        translationForVersion: true
      },
      {
        id: 2,
        name: 'components.faq',
        img: '/img/components/faqs/faq_illustr_2.jpg',
        version: 'V2',
        selector: 'faq',
        benefitsCount: 5,
        translationForVersion: true
      },
      {
        id: 3,
        name: 'components.faq',
        img: '/img/components/faqs/faq_illustr_3.jpg',
        version: 'V3',
        selector: 'faq',
        benefitsCount: 5,
        translationForVersion: true
      },
      {
        id: 4,
        name: 'components.guarantee',
        img: '/img/components/guarantee/guarantee_illustr_1.jpg',
        version: 'V1',
        selector: 'guarantee',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 5,
        name: 'components.guarantee',
        img: '/img/components/guarantee/guarantee_illustr_2.jpg',
        version: 'V2',
        selector: 'guarantee',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 6,
        name: 'components.guarantee',
        img: '/img/components/guarantee/guarantee_illustr_3.jpg',
        version: 'V3',
        selector: 'guarantee',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 7,
        name: 'components.event',
        img: '/img/components/events/event_illustr_1.jpg',
        version: 'V1',
        selector: 'event',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 8,
        name: 'components.event',
        img: '/img/components/events/event_illustr_2.jpg',
        version: 'V2',
        selector: 'event',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 9,
        name: 'components.event',
        img: '/img/components/events/event_illustr_3.jpg',
        version: 'V3',
        selector: 'event',
        benefitsCount: 3,
        translationForVersion: true
      },
      {
        id: 10,
        name: 'Custom HTML/CSS/Javascript',
        img: '/img/components/custom_html.jpg',
        version: 'V1',
        selector: 'custom_element',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 11,
        name: 'components.form',
        img: '/img/components/form/order_withbar_illustr_6.jpg',
        version: 'V1',
        selector: 'form',
        benefitsCount: 0,
        translationForVersion: true
      },
      {
        id: 12,
        name: 'components.form',
        img: '/img/components/form/order_withbar_illustr_7.jpg',
        version: 'V2',
        selector: 'form',
        benefitsCount: 0,
        translationForVersion: true
      }
    ]
  },
  {
    name: 'components.toolsCalc',
    selector: ['form'],
    items: [
      (!process.env['API_URL']?.includes('.ai') || !process.env['API_URL']?.includes('.com')) && {
        id: 1,
        name: 'components.tools',
        img: '/img/components/toolSection.png',
        version: 'V1',
        selector: 'custom_element_tool',
        benefitsCount: 0,
        translationForVersion: true,
        hasLimitation: true
      }
    ]
  }
];

export const subTitlePromptVal = `
  Craft a numeric list of single-sentence descriptions for a digital book about "{$INPUT}".
  Each description should be concise and avoid the use of semicolons, commas, or any other punctuation.
`;

export const baseKeysForPriceButtons = ['topbar_', 'hero_'];

export const FooterLinks = {
  listLinks: [
    // {
    //   linkText: "Frequently Asked Questions",
    //   path: "",
    // },
    {
      linkText: 'footer.learnWithUs',
      path: 'https://learn.pagewheel.com'
    },
    {
      linkText: 'footer.featureOrBug',
      path: 'hello@pagewheel.com'
    },
    {
      linkText: 'footer.becomePartner',
      path: 'https://pagewheel.com/become-a-partner'
    }
  ],
  links: [
    {
      linkText: 'footer.terms',
      path: 'https://learn.pagewheel.com/privacy-policy/'
    },
    {
      linkText: 'footer.privacy',
      path: 'https://learn.pagewheel.com/privacy-policy/'
    },
    {
      linkText: 'footer.contactUs',
      path: 'mailto:hello@pagewheel.com'
    }
  ]
};

export const purchasePlans = [
  {
    apiTitle: 'bizzy_free',
    title: 'Free',
    monthCost: 0,
    yearCost: 0,
    selectedCost: 0,
    content:
      'The perfect way to start your journey with Bizzy. You can create and brand your first product. Download and SELL!!',
    features: [
      'Design Your Project',
      'Access to over 25 PDF Batches',
      'Fully Editable Templates',
      'All Products Branded to YOU!!',
      'Commercial Resell Rights'
    ],
    appearance: null,
    productsCreated: 0,
    allowedProducts: 1
  },
  {
    apiTitle: 'bizzy_starter',
    title: 'The Starter',
    monthCost: 27,
    yearCost: 243,
    selectedCost: 27,
    content:
      'All of the features in our free version - AND we will even build and host your sales assets FOR YOU!!',
    features: [
      'Full Library with 100+ Pages',
      'Ability to Add Video Elements',
      'Unlimited Edits',
      'Unlimited Pages & Products',
      'Brand Kit for Social Promotion',
      '5 Sales Pages Written For You',
      'Hosting of Your Product Website'
    ],
    appearance: null,
    productsCreated: 0,
    allowedProducts: 5
  },
  {
    apiTitle: 'bizzy_business',
    title: 'Business',
    monthCost: 47,
    yearCost: 423,
    selectedCost: 47,
    content:
      'For the big businesses with enterprise-level needs. This is for companies who want access to support and trainings for growth.',
    features: [
      'Unlimited Products',
      'Unlimited Sales Pages',
      'Priority Support',
      'Ability to Publish with POD',
      'Create Fillable PDF Products'
    ],
    appearance: 'black',
    productsCreated: 0,
    allowedProducts: 1000000
  },
  {
    apiTitle: 'pw_enterprise_beta',
    title: 'Enterprise',
    monthCost: 99,
    yearCost: 891,
    selectedCost: 891,
    content: 'For the big businesses, get high level customizations and agency-tools',
    features: ['Serve Up to 10 Sub-Accounts', 'Agency Services Enabled', 'Whitelabel Capabilities'],
    appearance: 'black',
    productsCreated: 0,
    allowedProducts: 1000000
  }
];

export const fontSizeMapper = {
  LARGE_HEADLINE: {
    '1920': '50px',
    '1252': '44px',
    '991': '40px',
    '768': '34.5px',
    '575': '32.5px',
    '375': '29.5px'
  },
  HEADLINE: {
    '1920': '47px',
    '1252': '41px',
    '991': '37px',
    '768': '32.5px',
    '575': '30.5px',
    '375': '27.5px'
  },
  PARAGRAPH: {
    '1920': '26px',
    '1252': '20px',
    '991': '20px',
    '768': '22px',
    '575': '20px',
    '375': '20px'
  },
  SUBHEADLINE: {
    '1920': '30px',
    '1252': '24px',
    '991': '22px',
    '768': '22px',
    '575': '20px',
    '375': '20px'
  },
  TINY_TEXT: {
    '1920': '22px',
    '1252': '20px',
    '991': '20px',
    '768': '20px',
    '575': '20px',
    '375': '20px'
  }
};

export const ZOOM_SIZE = 0.72;
export const EDITOR_ZOOM_SIZE = ZOOM_SIZE - 0.16646;

export const ALERT_MESSAGE = {
  EDITING_IS_DISABLED_FOR_CHILD:
    'Editing is disabled for your account, please contact the parent account holder.'
};

export const AddonPlans = {
  accounts_first: {
    items: [
      {
        id: 0,
        accTitle: 'Add 1 Account ',
        accDesc: '$19 per user each month',
        monthly: 19,
        yearly: 190,
        name: 'addon_1_child'
      },
      {
        id: 1,
        accTitle: 'Add 10 Accounts',
        accDesc: '$15 per user each month',
        monthly: 150,
        yearly: 1800,
        name: 'addon_10_child'
      },
      {
        id: 2,
        accTitle: 'Add 100 Accounts',
        accDesc: '$11 per user each month',
        monthly: 1100,
        yearly: 13200,
        name: 'addon_100_child'
      }
    ]
  },
  accounts_second: {
    items: [
      {
        id: 0,
        accTitle: 'Add 250 Accounts',
        accDesc: '$8 per user each month',
        monthly: 2000,
        yearly: 24000,
        name: 'addon_250_child'
      },
      {
        id: 1,
        accTitle: 'Add 500 Accounts',
        accDesc: '$6 per user each month',
        monthly: 3000,
        yearly: 36000,
        name: 'addon_500_child'
      },
      {
        id: 2,
        accTitle: 'Add 1000 Accounts',
        accDesc: '$5 per user each month',
        monthly: 5000,
        yearly: 60000,
        name: 'addon_1000_child'
      }
    ]
  }
};

export const languages = {
  en: {
    name: 'English',
    icon: '/img/languages/united-states.png',
    lang: 'English',
    active: true
  },
  'es-mx': {
    name: 'Mexican Spanish',
    icon: '/img/languages/mexico.png',
    lang: 'Mexican Spanish',
    active: true
  },
  br: {
    name: 'Brazilian Portuguese',
    icon: '/img/languages/brazil.png',
    lang: 'Brazilian Portuguese',
    active: true
  },
  pt: {
    name: 'Portuguese',
    icon: '/img/languages/portugal.png',
    lang: 'Portuguese',
    active: true
  },
  es: {
    name: 'Spanish',
    icon: '/img/languages/spain.png',
    lang: 'Spanish (Castilian)',
    active: true
  },
  de: {
    name: 'German',
    icon: '/img/languages/germany.png',
    lang: 'German',
    active: true
  },
  it: {
    name: 'Italian',
    icon: '/img/languages/italy.png',
    lang: 'Italian',
    active: true
  },
  fr: {
    name: 'French',
    icon: '/img/languages/france.png',
    lang: 'French',
    active: false
  },
  nl: {
    name: 'Dutch',
    icon: '/img/languages/netherland.png',
    lang: 'Dutch',
    active: true
  },
  da: {
    name: 'Danish',
    icon: '/img/languages/denmark.png',
    lang: 'Danish',
    active: false
  },
  bg: {
    name: 'Bulgarian',
    icon: '/img/languages/bulgaria.png',
    lang: '/img/languages/Bulgarian',
    active: false
  },
  hu: {
    name: 'Hungarian',
    icon: '/img/languages/hungary.png',
    lang: 'Hungarian',
    active: false
  },
  sl: {
    name: 'Slovenia',
    icon: '/img/languages/slovenia.png',
    lang: 'Slovenian',
    active: true
  },
  'en-gb': {
    name: 'British English',
    icon: '/img/languages/united_kingdom.png',
    lang: 'British English',
    active: true
  },
  'ar-sa': {
    name: 'Arabic',
    icon: '/img/languages/saudi_arabia.png',
    lang: 'Arabic',
    active: true
  },
  ka: {
    name: 'Georgian',
    icon: '/img/languages/georgia.png',
    lang: 'Georgian',
    active: false
  }
};

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const languageMapping = {
  en: 'English',
  'es-mx': 'Spanish',
  'ar-sa': 'Arabic',
  br: 'Brazilian Portuguese',
  pt: 'Portuguese',
  es: 'Spanish',
  de: 'German',
  it: 'Italian',
  sl: 'Slovenian',
  nl: 'Dutch',
  ro: 'Romanian',
  bg: 'Bulgarian',
  fr: 'French',
  'en-gb': 'British English',
  ka: 'Georgian'
} as Record<string, string>;

export const CURRENCIES = {
  USD: '$',
  GBP: '£',
  AED: 'د.إ',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BMD: '$',
  BND: '$',
  CAD: '$',
  CDF: 'FC',
  CHF: 'CHF',
  CNY: '¥',
  CZK: 'Kč',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EGP: '£',
  ETB: 'Br',
  EUR: '€',
  FJD: '$',
  GEL: '₾',
  GIP: '£',
  GMD: 'D',
  HKD: '$',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  ISK: 'kr',
  JMD: '$',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KYD: '$',
  KZT: '₸',
  LBP: 'ل.ل',
  LKR: 'Rs',
  LRD: '$',
  LSL: 'L',
  MAD: 'د.م.',
  MDL: 'L',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'P',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NOK: 'kr',
  NPR: 'Rs',
  NZD: '$',
  PGK: 'K',
  PHP: '₱',
  PKR: 'Rs',
  PLN: 'zł',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'дин',
  RUB: '₽',
  SAR: '﷼',
  SBD: '$',
  SCR: 'Rs',
  SEK: 'kr',
  SGD: '$',
  SLE: 'Le',
  SOS: 'Sh',
  SZL: 'E',
  THB: '฿',
  TJS: 'ЅМ',
  TOP: 'T$',
  TRY: '₺',
  TTD: 'TT$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  WST: 'WS$',
  XCD: '$',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  AFN: '؋',
  AOA: 'Kz',
  ARS: '$',
  BOB: 'Bs.',
  BRL: 'R$',
  CLP: '$',
  COP: '$',
  CRC: '₡',
  CVE: '$',
  DJF: 'Fdj',
  FKP: '£',
  GNF: 'Fr',
  GTQ: 'Q',
  HNL: 'L',
  LAK: '₭',
  MUR: '₨',
  NIO: 'C$',
  PAB: 'B/.',
  PEN: 'S/.',
  PYG: '₲',
  SHP: '£',
  SRD: '$',
  STD: 'Db',
  UYU: '$U',
  XOF: 'CFA',
  XPF: '₣'
};

export const PRIMARY_CURRENCY_SYMBOLS = {
  $: 'USD',
  '£': 'GBP'
};

export const TOP_USED_CURRENCIES = {
  USD: '$',
  EUR: '€',
  CAD: '$',
  MXN: '$',
  GBP: '£',
  EGP: '£',
  GIP: '£',
  FKP: '£',
  SHP: '£'
};

export const STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  // Canada States
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Northwest Territories',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon'
];

export const stateCodes = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',

  // Canada
  Alberta: 'AB',
  'British Columbia': 'BC',
  Manitoba: 'MB',
  'New Brunswick': 'NB',
  'Newfoundland and Labrador': 'NL',
  'Nova Scotia': 'NS',
  'Northwest Territories': 'NT',
  Nunavut: 'NU',
  Ontario: 'ON',
  'Prince Edward Island': 'PE',
  Quebec: 'QC',
  Saskatchewan: 'SK',
  Yukon: 'YK'
};

/// TRANSCRIPT

export const PLATONI_PROMPT_TEMP = `in this video I show you how to view and get the transcript from YouTube videos if you're new to the Channel please go down below and consider subscribing and once you've done that please go down below and silly if you like and now let's go and jump straight into this guide the first thing you'll need to do is go to youtube.com and you'll need to do this on your computer or alternatively you candle on your mobile device but you'll need to go onto a browser and go to the desktop version of YouTube by requesting the desktop version of the website then the next thing you'll need to do is go and find the video which you want to go and get the transcript of so I'm going to go to my own channel and find a video I want to go and do the transcript for so here we are on my channel and I want to go over the transcript for this video here how to watch Netflix with friends so I'll just go and pause it just like so so scroll down a little bit on YouTube and what you need to do is just come just below the video player on the right hand side and go and tap on these three dots here go and tap on it just like so now as you can see I've now got this option here for show transcript so go and tap on show transcript just like so and then it's going to go and open up the transcript of everything I say in this video so then you can go and scroll through and go and view it and if you want to go and Skip to to a certain part of the video you can go and tap on the the timestamp just here and then it's going to go and take you that exact part of the video and also if you just want to go and remove the the timestamps as well then all you need to do is going to tap into three dots in the top right of the transcript box just like this and then you can go and press toggle timestamps and they'll be removed and if you want to go and say look for a certain keyword in the video all you need to do is press Ctrl F or command F if you're on a Mac and then you can go and type in for example um iPhone and then it's going to show you every time iPhone is mentioned in this video and you can go and tap on it and then you can go to that exact timestamp and you can also go and copy the transcript from YouTube as well to do that decide where you want to go and start copying from in this case I want to be at the start and then hold your left click down and you can just go and drag the whole thing just like so then let go and right click and go and press copy and then you go and paste it into a notepad and then I'm going to go and paste it in here just like so and there it is and then of course I can go and format it if I'd like to as well so there we go guys if you found this guide useful please go down below and so leave me a like peace`;

export const YoutubeTranscriptGenericPrompt2 = {
  prompt: `Split the transcript into 5 sections.  Give me a title for each section as well as supporting facts or stories for each. Format as
          “Section Title 1:” 
          “Supporting info 1:”
          “Section Title 2:”
          “Supporting Info 2:”
          “Section Title 3:” 
          “Supporting info 3:”
          “Section Title 4:” 
          “Supporting info 4:”
          “Section Title 5:” 
          “Supporting info 5:”`,
  mapping: {
    'section title 1': 'section title 1',
    'section title 2': 'section title 2',
    'section title 3': 'section title 3',
    'section title 4': 'section title 4',
    'section title 5': 'section title 5',
    'supporting info 1': 'supporting info 1',
    'supporting info 2': 'supporting info 2',
    'supporting info 3': 'supporting info 3',
    'supporting info 4': 'supporting info 4',
    'supporting info 5': 'supporting info 5'
  },
  types: {
    'section title 1': 'field',
    'section title 2': 'field',
    'section title 3': 'field',
    'section title 4': 'field',
    'section title 5': 'field',
    'supporting info 1': 'field',
    'supporting info 2': 'field',
    'supporting info 3': 'field',
    'supporting info 4': 'field',
    'supporting info 5': 'field'
  }
};

export const YoutubeTranscriptGenericPrompt3 = {
  prompt: `Based on the transcript, provide a one-page summary as if it were the first page of a book on that topic. Write as if you are teasing the topic to your friend.  Do not use the word book. We also need a teaser paragraph.  Format the summary as
          "Book title:"
          "Page Summary:"
          “Book Teaser Paragraph:”
`,
  mapping: {
    'book title': 'book title',
    'page summary': 'page summary',
    'book teaser paragraph': 'book teaser paragraph'
  },
  types: {
    'book title': 'field',
    'page summary': 'field',
    'book teaser paragraph': 'field'
  }
};

export const turnTakewaysIntoString = (takeways: Record<string, string>) => {
  let output = '';
  [1, 2, 3, 4, 5].forEach((i) => {
    output += `${takeways[`section title ${i}`] ?? ''}\n`;
    output += `${takeways[`supporting info ${i}`] ?? ''}\n\n`;
  });
  return output;
};

export const replaceAllStaticVariablesInTranscriptPrompt = (
  prompt: string,
  parsedTranscript: Record<string, string>
) => {
  let text = prompt;
  [1, 2, 3, 4, 5].forEach((i) => {
    text = text.replace(
      `{TRANSCRIPT_SECTION_TITLE_${i}}`,
      parsedTranscript?.[`section title ${i}`] || ''
    );
    text = text.replace(
      `{TRANSCRIPT_SUPPORTING_INFO_${i}}`,
      parsedTranscript?.[`supporting info ${i}`] || ''
    );
  });
  return text;
};

/// TRANSCRIPT
